import React, { useEffect, useState } from 'react';
import {useUser} from "../../../Services/userProvider";
import {toast} from "react-toastify";
import ManifestAPI from "../../../apis/manifestApi/manifestAPI";
import Pagination from "../../assets/Pagination";
import TableLoader from "../../loaders/TableLoader";
import Moment from "moment/moment";
import PrintComponent from "./printer";
import PrintFretComponent from "./printerFret";

const DailyFretsByBus = () => {
    const user = useUser();

    const [total, setTotal] = useState("");
    const [dailyFrets, setDailyFrets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [setting, setSetting] = useState([]);

    const [vivo, setOutPutData] = useState([]);
    const [startAt, setStartAt] = useState("");
    const [endAt, setEndAt] = useState("");

    const fetchSetting = async () => {
        try{
            const data =  await ManifestAPI.findSetting();
            setSetting(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des paramettres !");
        }
    };

    const getDailyFrets = async () => {
        try{
            const data =  await ManifestAPI.dailyFrets();
            setDailyFrets(data.buses);
            setOutPutData(data.buses);
            setTotal(data.total);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des frets du jours !");
        }
    };

    useEffect(() => {
        getDailyFrets();
        fetchSetting();
    },[]);


    //Gestion du changement de page
    const handleChangeCurrentPage = page => {
        setCurrentPage(page);
    };

    //Gestion de la recherche
    const handleSearch = ({currentTarget}) => {
        setSearch(currentTarget.value);
        setCurrentPage(1);
    };

    const itemsPerPage = 100;

    //Filtrage des buses en fonction de la recherche
    const filteredFrets = vivo.filter(
        b =>
            b.bus_numberplate.toLowerCase().includes(search.toLowerCase()) ||
            b.to.toLowerCase().includes(search.toLowerCase()) ||
            b.vendor_name.toLowerCase().includes(search.toLowerCase()) ||
            b.from.toLowerCase().includes(search.toLowerCase())
    );

    //Pagination des données
    const paginatedFrets = Pagination.getData(
        filteredFrets,
        currentPage,
        itemsPerPage
    );

    console.log(filteredFrets);



    let counter = 1;

    function calculTotal(data) {
        let tCDF = 0;
        data.map((toto) => toto.tickets.map((ticket) => tCDF += ticket.amount));
        return tCDF
    }

    function calculSubTotal(data) {
        let tCDF = 0;
        data.map((ticket) => tCDF += ticket.amount);
        return tCDF
    }

    const handleStartedDate = ({currentTarget}) => {
        setStartAt(currentTarget.value);
        setCurrentPage(1);
    };

    const handleEndedDate = ({currentTarget}) => {
        setEndAt(currentTarget.value);
        setCurrentPage(1);
    };

    const handleBtns = () => {

        if(startAt !== "" && endAt === "") {
            const filtered = dailyFrets.filter(
                item => Moment(item.created_at).format("YYYY/MM/DD") === Moment(startAt).format("YYYY/MM/DD"));
            setOutPutData(filtered);
        } else if (startAt !== "" && endAt !== "") {
            const filtered = dailyFrets.filter(
                item => Moment(item.created_at).format("YYYY/MM/DD") >= Moment(startAt).format("YYYY/MM/DD")
                    && Moment(item.created_at).format("YYYY/MM/DD") <= Moment(endAt).format("YYYY/MM/DD"));
            setOutPutData(filtered);
        }else{
            const filtered = dailyFrets.filter(item=>
                Moment(item.created_at).format("YYYY/MM/DD") >= Moment(startAt).format("YYYY/MM/DD"));
            setOutPutData(filtered)
        }

    };

    const manifestByDestination = (data) => {
        const destinations = data.map((key, value) => key = key.city_to);
        let data_table = [];
        destinations.forEach((val) => {
            if (data_table[val]) {
                data_table[val] += 1;
            } else {
                data_table[val] = 1;
            }
        });

        return data_table;
    };

    const passagerByDestination = (data) => {
        const destinations = data.map((key, value) => key = key.destination);
        let data_table = [];
        destinations.forEach((val) => {
            if (data_table[val]) {
                data_table[val] += 1;
            } else {
                data_table[val] = 1;
            }
        });

        return data_table;
    };


    return (
        <div className="container">
            <div className="row">

                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-10">
                                    {/*<h2 className="card-title">*/}
                                        {/*Total : <b className="text-primary">{paginatedAllTikets ? paginatedAllTikets.length : 0} </b> |*/}
                                        {/*Bus : {total && (<><b className="text-success">{calculTotal(paginatedAllTikets)}</b> CDF</>)} |*/}
                                        {/*Fret : {total && (<><b className="text-success">{calculTotalFret(allFrets)}</b> CDF</>)}*/}
                                    {/*</h2>*/}

                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group mt-3">
                                        <label htmlFor="ByAll" className="text-dark">
                                            Recherche par Bus
                                        </label>
                                        <input type="text" onChange={handleSearch} value={search}
                                               name="ByAll" id="ByAll" className="form-control"
                                               placeholder="Rechercher ..."
                                               autoComplete="off"
                                        />
                                    </div>
                                </div>

                                {/*<div className="col-md-2">*/}
                                    {/*<div className="form-group mt-4 d-flex float-end">*/}
                                        {/*<PrintComponent type="billet" critere={search} data={filteredAllTikets} />*/}
                                    {/*</div>*/}
                                {/*</div>*/}
                            </div>


                            <hr/>
                            {!loading && <ol className="list-group list-group-numbered">
                                {paginatedFrets.map((bus) => (
                                    <div key={bus.id}>
                                        <li className="list-group-item d-flex justify-content-between align-items-start">
                                            <div className="ms-2 me-auto">
                                                <div className="fw-bold"><span className="text-success">{bus.bus_numberplate}</span></div>
                                                vers : <b>{bus.to}</b>, Depart : {bus.bus_hour}<br/>
                                                <span className="">
                                                {/*<b className="text-success">{calculSubTotal(bus.colis)} Fc </b>*/}
                                            </span>
                                                <small>
                                                    <b className="text-danger">Le {Moment(bus.created_at).format("DD/MM/YYYY")}</b>,
                                                    Vendeur <b>{bus.vendor_name}</b> <br/>
                                                    Chauffeur : <b>{bus.driver_name}</b>, Escorteur : <b>{bus.manager_name}</b>
                                                </small>
                                            </div>

                                            <b className="">{bus.colis.length} Colis embarqués</b>
                                            <a className="badge bg-success mx-2" data-bs-toggle="collapse"
                                               href={"#tickets"+bus.id} role="button" aria-expanded="false"
                                               aria-controls={"tickets"+bus.id}>Voir <i className="bi bi-eye"></i> </a>

                                            <div className="btn-group me-2">
                                                <button className="btn btn-success btn-sm dropdown-toggle"
                                                        type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    Manifest passagers
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li>
                                                        <a className="dropdown-item btn-group-vertical" role="group"
                                                             aria-label="Basic example">

                                                    {passagerByDestination(bus.tickets).Lubumbashi && (
                                                        <button className="btn btn-sm btn-primary">
                                                            <PrintComponent color="success" keyWord="Lubumbashi" bus={bus} setting={setting}/>
                                                        </button>)}

                                                    {passagerByDestination(bus.tickets).Kolwezi && (
                                                        <button className="btn btn-sm btn-success">
                                                            <PrintComponent color="primary" keyWord="Kolwezi" bus={bus} setting={setting}/>
                                                        </button> )}

                                                    {passagerByDestination(bus.tickets).Likasi && (
                                                        <button className="btn btn-sm btn-dark">
                                                            <PrintComponent color="dark" keyWord="Likasi" bus={bus} setting={setting}/>
                                                        </button>)}

                                                    {passagerByDestination(bus.tickets).Fungurume && (
                                                        <button className="btn btn-sm btn-danger">
                                                            <PrintComponent color="danger" keyWord="Fungurume" bus={bus} setting={setting}/>
                                                        </button>)}

                                                    {passagerByDestination(bus.tickets).Kasumbalesa && (
                                                        <button className="btn btn-sm btn-warning">
                                                            <PrintComponent color="info" keyWord="Kasumbalesa" bus={bus} setting={setting}/>
                                                        </button>)}

                                                    {passagerByDestination(bus.tickets).Sakania && (
                                                        <button className="btn btn-sm btn-primary">
                                                            <PrintComponent color="warning" keyWord="Sakania" bus={bus} setting={setting}/>
                                                        </button>)}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className="btn-group">
                                                <button className="btn btn-primary btn-sm dropdown-toggle"
                                                        type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    Manifeste colis
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li>
                                                        <a className="dropdown-item btn-group-vertical" role="group"
                                                           aria-label="Basic example">

                                                            {manifestByDestination(bus.colis).Lubumbashi && (
                                                                <button className="btn btn-sm btn-primary">
                                                                    <PrintFretComponent color="success" keyWord="Lubumbashi" bus={bus} setting={setting}/>
                                                                </button>)}

                                                            {manifestByDestination(bus.colis).Kolwezi && (
                                                                <button className="btn btn-sm btn-success">
                                                                    <PrintFretComponent color="primary" keyWord="Kolwezi" bus={bus} setting={setting}/>
                                                                </button> )}

                                                            {manifestByDestination(bus.colis).Likasi && (
                                                                <button className="btn btn-sm btn-dark">
                                                                    <PrintFretComponent color="dark" keyWord="Likasi" bus={bus} setting={setting}/>
                                                                </button>)}

                                                            {manifestByDestination(bus.colis).Fungurume && (
                                                                <button className="btn btn-sm btn-danger">
                                                                    <PrintFretComponent color="danger" keyWord="Fungurume" bus={bus} setting={setting}/>
                                                                </button>)}

                                                            {manifestByDestination(bus.colis).Kasumbalesa && (
                                                                <button className="btn btn-sm btn-warning">
                                                                    <PrintFretComponent color="info" keyWord="Kasumbalesa" bus={bus} setting={setting}/>
                                                                </button>)}

                                                            {manifestByDestination(bus.colis).Sakania && (
                                                                <button className="btn btn-sm btn-primary">
                                                                    <PrintFretComponent color="warning" keyWord="Sakania" bus={bus} setting={setting}/>
                                                                </button>)}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>



                                        </li>
                                        <div className="collapse multi-collapse" id={"tickets"+bus.id}>
                                            <div className="card card-body">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <table className="table table-hover table-striped">
                                                            <thead>
                                                            <tr>
                                                                <th scope="col">N°</th>
                                                                <th scope="col">Exp</th>
                                                                <th scope="col">Tél</th>
                                                                <th scope="col">Code</th>
                                                                <th scope="col">Designation</th>
                                                                <th scope="col">Nombre</th>
                                                                <th scope="col">Destinataire</th>
                                                                <th scope="col">Tél</th>
                                                                <th scope="col">Destinatation</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {bus.colis.map((fret) => (
                                                                <tr key={fret.id}>
                                                                    <td>{counter++}</td>
                                                                    <td>{fret.expediteur}</td>
                                                                    <td>{fret.expediteur_phone}</td>
                                                                    <td><b>{fret.reference}</b></td>
                                                                    <td>{fret.name}</td>
                                                                    <td className="text-center"><b>{fret.code}</b></td>
                                                                    <td>{fret.recipient}</td>
                                                                    <td>{fret.recipient_phone}</td>
                                                                    <td>{fret.city_to}</td>
                                                                    <td>
                                                                        {/*<button*/}
                                                                        {/*onClick={() => {*/}
                                                                        {/*if (window.confirm('Etes-vous sûr(e) de vouloir effectuer cette action ?')) {*/}
                                                                        {/*handleDelete(ticket.id)*/}
                                                                        {/*}*/}
                                                                        {/*}}*/}
                                                                        {/*className="btn btn-sm btn-danger">*/}
                                                                        {/*Sup*/}
                                                                        {/*</button>*/}
                                                                    </td>

                                                                </tr>
                                                            ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                            </ol>}
                        </div>
                        {loading && <TableLoader width={300} height={350} />}

                        {itemsPerPage < filteredFrets.length &&
                        <Pagination
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            length={filteredFrets.length}
                            onPageChange={handleChangeCurrentPage}
                        />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DailyFretsByBus;
